import React, { useEffect } from "react"

// components
import Banner from "../components/banner"
// import PageTitle from "../components/pageTitle"
import SingThursday from "../components/video/singThursday"
import Releases from "../components/video/releases"
import Footer from "../components/footer"

// data
import videos from "../data/videos"

const Video = () => {
  useEffect(() => {
    document.title = "Videos - Soz the govt Music Production"
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const singThursday = videos.filter((o) => o.singThursday === true)
  const releases = videos.filter((o) => o.singThursday !== true)

  return (
    <div className="media-page">
      <Banner bannerClass="media-banner videos-banner">
        <h1>Releases</h1>
      </Banner>
      {/* <PageTitle
        title="Take a look on our previous work"
        subtitle="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio."
      ></PageTitle> */}
      <main>
        <div className="container">
          <article className="row video-row">
            <section className="column">
              <Releases releases={releases} />
              <SingThursday singThursday={singThursday} />
            </section>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Video
